import {
  buildOrderSummaryPath,
  buildProductStepPath,
  getCompletedSteps,
  getStepsForProductType,
} from "@jasper/product-workflows";
import { useOrderConfiguration } from "@jasper/use-cases";
import { Loader, Stack } from "@mantine/core";
import { Navigate, useOutletContext } from "react-router-dom";

const ResumeOrderConfiguration = () => {
  const { orderId } = useOutletContext<{ orderId: string }>();
  const { order, isLoading } = useOrderConfiguration({ orderId });

  if (isLoading || !order) {
    return (
      <Stack h="100%" w="100%" justify="center" align="center">
        <Loader />
      </Stack>
    );
  }

  for (const product of order.products ?? []) {
    const completedStepKeys = getCompletedSteps(product);
    const nextStep = getStepsForProductType(product.type).find(
      step => !completedStepKeys.includes(step.key)
    );

    if (nextStep) {
      return (
        <Navigate
          to={buildProductStepPath(orderId, product.id, nextStep.key)}
          replace
        />
      );
    }
  }

  return <Navigate to={buildOrderSummaryPath(orderId)} replace />;
};

export default ResumeOrderConfiguration;
